
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "32px",
    "height": "32px",
    "viewBox": "0 0 32 32",
    "enable-background": "new 0 0 32 32",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "currentColor",
        "width": "32",
        "height": "32"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "currentColor",
        "d": "M23.327,10.292c-0.348,0-0.627,0.265-0.627,0.591v12.389c0,0.844-0.73,1.559-1.593,1.559H10.954\n\tc-0.863,0-1.592-0.715-1.592-1.559V10.883c0-0.326-0.281-0.591-0.627-0.591s-0.626,0.265-0.626,0.591v12.389\n\tc0,1.483,1.303,2.738,2.845,2.738h10.153c1.542,0,2.847-1.255,2.847-2.738V10.883C23.954,10.557,23.674,10.292,23.327,10.292z\n\t M24.396,8.522H7.651c-0.347,0-0.627,0.266-0.627,0.59c0,0.326,0.28,0.591,0.627,0.591h16.745c0.347,0,0.628-0.265,0.628-0.591\n\tC25.024,8.788,24.743,8.522,24.396,8.522z M17.962,7.734c0,0,0.001-0.017,0.001-0.02c0-0.938-0.808-1.705-1.805-1.705\n\tc-0.999,0-1.806,0.769-1.806,1.708c0,0.005,0.001,0.017,0.001,0.017H17.962z M12.688,22.257V12.32c0-0.325-0.279-0.592-0.626-0.592\n\tc-0.348,0-0.627,0.267-0.627,0.592v9.937c0,0.324,0.279,0.589,0.627,0.589C12.408,22.846,12.688,22.581,12.688,22.257z\n\t M16.408,22.257V12.32c0-0.325-0.28-0.592-0.626-0.592c-0.347,0-0.629,0.267-0.629,0.592v9.937c0,0.324,0.282,0.589,0.629,0.589\n\tC16.128,22.846,16.408,22.581,16.408,22.257z M20.127,22.257V12.32c0-0.325-0.28-0.592-0.628-0.592\n\tc-0.346,0-0.626,0.267-0.626,0.592v9.937c0,0.324,0.28,0.589,0.626,0.589C19.847,22.846,20.127,22.581,20.127,22.257z"
      }
    }
  ]
})
    }
  